import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const ccoeCloudOnboardingPlugin = createPlugin({
  id: 'ccoe-cloud-onboarding',
  routes: {
    root: rootRouteRef,
  },
});

export const CcoeCloudOnboardingPage = ccoeCloudOnboardingPlugin.provide(
  createRoutableExtension({
    name: 'CcoeCloudOnboardingPage',
    component: () => import('./components/DashboardView').then((m) => m.DashboardView),
    mountPoint: rootRouteRef,
  }),
);
